<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding: 10px">
        <template>

          <el-tabs type="border-card" :before-leave='beforeLeave' v-model="activeName"
                   style="height:350px">
            <el-tab-pane v-for="(item,i) in tableData" :key="i" :label="item.name">
              <component :is="item.currentRole" ref="component"/>
            </el-tab-pane>
          </el-tabs>

        </template>
      </div>
    </div>

    <AlarmInfo ref="AlarmInfo"  v-show="alarmInfoShow" > </AlarmInfo>
    <Blood ref="Blood"  v-show="bloodShow" ></Blood>
    <Heart ref="Heart"  v-show="heartShow" ></Heart>
    <Oxygen ref="Oxygen"  v-show="oxygenShow" ></Oxygen>
    <Temp ref="Temp"  v-show="tempShow" ></Temp>
    <BloodSugar ref="BloodSugar"  v-show="bloodSugarShow" ></BloodSugar>
    <Step ref="Step"  v-show="stepShow" ></Step>

  </div>
</template>

<script>

import AlarmInfo from "./AlarmInfo";
import Blood from "./Blood";
import Heart from "./Heart";
import Oxygen from "./Oxygen";
import Temp from "./Temp";
import BloodSugar from "./BloodSugar";
import Step from "./Step";


export default {
  name: "WatchData",
  data() {
    return {
      bloodShow:false,
      alarmInfoShow:false,
      heartShow:false,
      oxygenShow:false,
      tempShow:false,
      bloodSugarShow:false,
      stepShow:false,

      userDeviceCode: '',
      userCode: '',

      activeName:'0',
      tableData: [
        {name: '报警信息',currentRole:'AlarmInfo',isNone:true},
        {name: '血压',currentRole:'Blood',isNone:false},
        {name: '心率',currentRole:'Heart',isNone:false},
        {name: '血氧',currentRole:'Oxygen',isNone:false},
        {name: '体温',currentRole:'Temp',isNone:false},
        {name: '血糖',currentRole:'BloodSugar',isNone:false},
        {name: '步数',currentRole:'Step',isNone:false},
      ],

    }
  },
  components: {
    AlarmInfo,Blood,Heart,Oxygen,Temp,BloodSugar,Step
  },

  methods: {

    init(row) {
      this.userDeviceCode = row.userDeviceCode;
      this.userCode = row.userCode;

      this.tableData.forEach((item)=>{
        item.isNone=false
      })

      this.activeName='0'
      this.tableData[0].isNone=true
      this.$nextTick(() => {
        this.$refs.component[0].init2(row.userDeviceCode,row.userCode)
      })

    },
    closeSelf() {
      this.$emit("closeWatchData");
    },

    beforeLeave(activeName){
      this.tableData[parseInt(activeName)].isNone=true
      this.$nextTick(() => {
          this.$refs.component[parseInt(activeName)].init2(this.userDeviceCode,this.userCode)
      })
    }


  },

}


</script>

<style lang="scss" scoped>

</style>
